// Recipient list attribute: a JSON array of addresses edited in a textarea, not a
// single address field.

import React from 'react';
import TextArea from '@decisiv/ui-components/lib/components/TextArea';

import { fieldPropTypes } from './fieldPropTypes';

const EmailInput = ({
  descriptor,
  label,
  value,
  warningMessage = '',
  readOnly = true,
  onChange,
  onBlur,
}) => (
  <TextArea
    name={descriptor.name}
    label={label}
    required={descriptor.required}
    helpMessage={descriptor.description}
    warningMessage={warningMessage}
    disabled={readOnly}
    value={value ?? ''}
    onChange={(e) => onChange(descriptor.name, e.target.value)}
    onBlur={() => onBlur?.(descriptor.name)}
  />
);

EmailInput.propTypes = fieldPropTypes;

export default EmailInput;
